import { Dispatch } from 'redux'

import { Menu } from '@library/menu-service'

import * as trackingKeys from 'actions/trackingKeys'
import type { MenuRequest } from 'reducers/menu-metadata/metadata'

import { actionTypes } from '../actionTypes'

export function menuServiceV3DataReceived(request: MenuRequest, response: Menu) {
  return (dispatch: Dispatch<any>) => {
    dispatch({
      type: actionTypes.MENU_SERVICE_V3_DATA_RECEIVED,
      request,
      response,
      trackingData: {
        actionType: trackingKeys.receiveMenuServiceDataV3,
      },
    })
  }
}
